function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16 17a1 1 0 011 1v4a1 1 0 11-2 0v-4a1 1 0 011-1z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.001 11.054A1.02 1.02 0 018 11V8a7 7 0 017-7h2a7 7 0 017 7v3l-.001.054A11.97 11.97 0 0128 20c0 6.627-5.373 12-12 12S4 26.627 4 20a11.97 11.97 0 014.001-8.946zM10 8a5 5 0 015-5h2a5 5 0 015 5v1.605A11.945 11.945 0 0016 8c-2.186 0-4.235.584-6 1.605V8zm6 2c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10z",
  fill: "currentColor"
})));